var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.857 3C3.83141 3 3 3.83141 3 4.857V9.143C3 10.1686 3.83141 11 4.857 11H9.143C10.1686 11 11 10.1686 11 9.143V4.857C11 3.83141 10.1686 3 9.143 3H4.857ZM14.857 3C13.8314 3 13 3.83141 13 4.857V9.143C13 10.1686 13.8314 11 14.857 11H19.143C20.1686 11 21 10.1686 21 9.143V4.857C21 3.83141 20.1686 3 19.143 3H14.857ZM4.857 13C3.83141 13 3 13.8314 3 14.857V19.143C3 20.1686 3.83141 21 4.857 21H9.143C10.1686 21 11 20.1686 11 19.143V14.857C11 13.8314 10.1686 13 9.143 13H4.857ZM18 14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14V16H14C13.4477 16 13 16.4477 13 17C13 17.5523 13.4477 18 14 18H16V20C16 20.5523 16.4477 21 17 21C17.5523 21 18 20.5523 18 20V18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H18V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPlus);
export default __webpack_public_path__ + "static/media/grid-plus.512e1b8aa8846482cb30882a030f21ea.svg";
export { ForwardRef as ReactComponent };